import React from 'react';

export default function CompleteLoading(props) {
  return (
    <div className="complete-loading-wrapper">
      <div className="complete-loading">
        <h1 className="text-center">{props.message}</h1>
      </div>
    </div>
  );
}
